<script setup lang="ts">import { ref as _ref, computed as _computed } from 'vue';

import BotFooter from '@/components/BotFooter.vue'
import TopNav from '@/components/TopNav.vue'
import { ourServices } from '@/data/ourServices'
import { useLangTools } from '@/lang'
import { useRouter } from 'vue-router'

const { $tdb } = useLangTools(useRouter())
const serviceTabActive = _ref(ourServices[0]._id)

const selectedService = _computed(() => ourServices.find(service => serviceTabActive.value === service._id))
</script>

<template>
	<div>
		<div class="act_oval" />
		<TopNav />
		<div class="page-wrap relative">
			<div class="act_w1170 grid act_gap-3 our-services act_pt-1">
				<div class="our-services-tabs-wrap">
					<h1 class="playfair act_txt60 act_no-marg balance act_pb-2">
						{{ $t("general.ourServices") }}
					</h1>
					<div class="our-services-tabs-slide">
						<div
							v-for="service in ourServices" :key="service._id"
							class="our-services-tabs hover act_round" :class="{ serviceTabActive: serviceTabActive === service._id }" @click="serviceTabActive = service._id"
						>
							<p class="playfair act_txt30">
								{{ $tdb(service, 'name') }}
							</p>
						</div>
					</div>
				</div>

				<div>
					<div class="act_white-box">
						<img
							class="rounded our-services-img" height="300" :src="selectedService?.image.imageURL"
							:alt="$tdb(selectedService, 'name')"
						>

						<p class="playfair act_txt40 act_pb-05">
							{{ $tdb(selectedService, 'name') }}
						</p>
						<p class="playfair act_txt24 act_pb-2">
							{{ $tdb(selectedService, 'subtitle') }}
						</p>

						<div v-html="$tdb(selectedService, 'body')" />
					</div>
				</div>
			</div>
		</div>
		<BotFooter />
	</div>
</template>

<style>
.our-services {
  grid-template-columns: minmax(320px, calc(100% - 720px)) 1fr;
  align-items: start;
}

.our-services img {
  width: 100%;
  object-fit: cover;
  object-position: center;
  margin-top: -10rem;
  margin-bottom: 2rem;
}

.our-services-tabs {
  padding: 2rem;
  color: var(--blue);
}

.our-services-tabs-wrap {
  position: sticky;
  top: 5rem;
}

.our-services .act_white-box {
  margin-top: 10rem;
}

.our-services blockquote {
  font-family: 'Playfair Display', serif;
  text-align: center;
  text-wrap: balance;
  padding: 1rem;
}

.our-services-tabs.serviceTabActive {
  background: linear-gradient(90deg, rgba(88, 191, 235, 0.20) 1.58%, rgba(88, 191, 235, 0.00) 100%);
  color: white;
}

@media screen and (max-width: 900px) {
  .our-services {
    grid-template-columns: 1fr;
  }

  .our-services img {
    width: 100%;
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
    display: block;
    margin-top: 0;
    margin-bottom: 1rem;
    max-height: 40vw;
  }

  .our-services-tabs {
    padding: 0.75rem;
    width: 30%;
  }

  .our-services-tabs p {
    font-size: 16px;
    text-align: center;
  }

  .our-services-tabs-wrap {
    position: relative;
    top: 0rem;
    margin-bottom: -1rem;
  }

  .our-services .act_white-box {
    margin-top: 0;
  }

  .our-services .act_txt40 {
    font-size: 28px;
  }

  .our-services-tabs-slide {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }

  .our-services-tabs.serviceTabActive {
    background: linear-gradient(180deg, rgba(88, 191, 235, 0.20) 1.58%, rgba(88, 191, 235, 0.00) 100%);
  }
}
</style>
